// V_TC_PDP_41 | Half Off Price Anchoring (Winner: Var A)
//
// Ordering note: this script runs AFTER Intelligems has done its price
// replacements. We gate the initial run on Intelligems' onLoad callback
// (with a polling fallback + hard timeout) so anchoring always reads
// the post-IG prices. Mutation-driven re-runs are also debounced so IG
// gets a tick to react to new nodes before we recompute the anchor.

(function () {
  var IG_READY_TIMEOUT_MS = 5000;
  // After igLoaded === true, we wait up to this long for IG to actually
  // mutate a price element before running anchor. The first observed
  // mutation triggers anchor immediately; otherwise we fire on timeout
  // (this is the control-group / not-in-test case).
  var IG_PRICE_MUTATION_TIMEOUT_MS = 1500;
  var POST_MUTATION_DEFER_MS = 30;
  var FAILSAFE_REVEAL_MS = 6000;

  // Fail-safe: even if anchor never runs (script error, IG never loads,
  // etc.), reveal any veiled .price elements so the page is not left
  // blank. The veil CSS in theme.liquid keys on this html class.
  setTimeout(function () {
    document.documentElement.classList.add("c-anchor-failsafe");
  }, FAILSAFE_REVEAL_MS);

  // Wait for Intelligems readiness in two phases:
  //   1. Poll window.igLoaded === true (the plugin's load signal). This
  //      tells us the plugin has booted but NOT necessarily that test
  //      prices have been installed into the DOM yet — that happens
  //      asynchronously after igLoaded.
  //   2. Once igLoaded, observe a sample card price element. The first
  //      time IG mutates its text, we know IG has finished installing
  //      its test prices and it is safe for anchor to read them. If no
  //      mutation occurs within IG_PRICE_MUTATION_TIMEOUT_MS we run
  //      anchor anyway (covers the control-group / no-test-applies case
  //      where IG legitimately leaves prices untouched).
  function whenIntelligemsReady(cb) {
    function afterLoaded() { waitForIgPriceMutation(cb); }
    if (window.igLoaded === true) { afterLoaded(); return; }
    var start = Date.now();
    var iv = setInterval(function () {
      if (window.igLoaded === true) {
        clearInterval(iv);
        afterLoaded();
      } else if (Date.now() - start > IG_READY_TIMEOUT_MS) {
        clearInterval(iv);
        afterLoaded();
      }
    }, 25);
  }

  function waitForIgPriceMutation(cb) {
    // Pick a stable target: the first .igPrice still on the page.
    // Anchor is the only thing that strips that class, and at this point
    // anchor has not run yet, so any .igPrice we find is one that IG
    // will potentially rewrite.
    var target = document.querySelector(".igPrice");
    if (!target) { cb(); return; }
    var done = false;
    function fire() {
      if (done) return;
      done = true;
      try { obs.disconnect(); } catch (e) {}
      clearTimeout(to);
      cb();
    }
    var obs = new MutationObserver(fire);
    obs.observe(target, { childList: true, characterData: true, subtree: true });
    var to = setTimeout(fire, IG_PRICE_MUTATION_TIMEOUT_MS);
  }

  // Once anchor has read the IG-installed price from a card, detach the
  // card's price spans from IG's continuous monitoring so IG won't fight
  // anchor's own DOM rewrites.
  function detachIntelligemsHooks(priceEl) {
    var sels = [".igPrice", ".igComparePrice"];
    for (var i = 0; i < sels.length; i++) {
      var nodes = priceEl.querySelectorAll(sels[i]);
      for (var j = 0; j < nodes.length; j++) {
        nodes[j].classList.remove("igPrice");
        nodes[j].classList.remove("igComparePrice");
        nodes[j].removeAttribute("data-product-id");
        nodes[j].removeAttribute("data-variant-id");
      }
    }
    priceEl.removeAttribute("data-product-id");
    priceEl.removeAttribute("data-variant-id");
  }

  function init() {

  var discountTagSVGEl = document.getElementById("c-discount-tag-svg");
  var discountTagSVG = discountTagSVGEl ? discountTagSVGEl.innerHTML : "";

  var discountBadgeSVGEl = document.getElementById("c-discount-badge-svg");
  var discountBadgeSVG = discountBadgeSVGEl ? discountBadgeSVGEl.innerHTML : "";

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function calcAnchorPrices(priceInCents) {
    var halfPrice = Math.round(priceInCents / 0.8);
    var inflatedPrice = halfPrice * 2;
    return { halfPrice: halfPrice, inflatedPrice: inflatedPrice };
  }

  function getInitialVariantPrice() {
    var meta =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product;
    if (!meta || !meta.variants) return null;
    var urlVariantId = new URLSearchParams(window.location.search).get(
      "variant"
    );
    var variant =
      meta.variants.find(function (v) {
        return String(v.id) === urlVariantId;
      }) || meta.variants[0];
    return variant ? variant.price : null;
  }

  function parsePriceFromDOM() {
    var el = document.querySelector(".product-page-price .price-item--sale");
    if (!el)
      el = document.querySelector(".product-page-price .price-item--regular");
    if (!el) return null;
    var text = el.textContent.replace(/[^0-9.]/g, "");
    var val = parseFloat(text);
    return isNaN(val) ? null : Math.round(val * 100);
  }

  function renderPDPBlock(priceInCents) {
    var existing = document.querySelector(".c-price-anchor-block");
    if (existing) existing.remove();

    var prices = calcAnchorPrices(priceInCents);

    var block = document.createElement("div");
    block.className = "c-price-anchor-block";
    block.innerHTML =
      '<div class="c-price-anchor-original">' +
      '<span class="c-price-anchor-original-label">Original Price</span>' +
      '<s class="c-price-anchor-original-value">' +
      formatMoney(prices.inflatedPrice) +
      "</s>" +
      "</div>" +
      '<div class="c-price-anchor-half">' +
      '<div class="c-price-anchor-half-left">' +
      '<span class="c-price-anchor-half-icon">' +
      discountBadgeSVG +
      "</span>" +
      '<div class="c-price-anchor-half-text">' +
      "<strong>Early Black Friday Price</strong>" +
      "<span>SALE ENDS SOON!</span>" +
      "</div>" +
      "</div>" +
      '<span class="c-price-anchor-half-price">' +
      formatMoney(prices.halfPrice) +
      "</span>" +
      "</div>";

    var priceContainer = document.querySelector(".product-page-price");
    if (priceContainer) {
      priceContainer.insertAdjacentElement("afterend", block);
    }
  }

  function updatePDPBlock(priceInCents) {
    var originalValue = document.querySelector(
      ".c-price-anchor-original-value"
    );
    var halfPriceEl = document.querySelector(".c-price-anchor-half-price");
    if (!originalValue || !halfPriceEl) {
      renderPDPBlock(priceInCents);
      return;
    }
    var prices = calcAnchorPrices(priceInCents);
    originalValue.textContent = formatMoney(prices.inflatedPrice);
    halfPriceEl.textContent = formatMoney(prices.halfPrice);
  }

  function setATCButtonText() {
    var btn = document.querySelector(".main-product-atc");
    if (!btn || btn.disabled) return;
    var label = btn.querySelector(".main-atc__label__text");
    if (label) label.textContent = "Add to Cart & Get An Extra 20% OFF";
  }

  function runPDP() {
    if (!window.location.pathname.includes("/products/")) return;
    // Read the post-IG DOM price first. window.ShopifyAnalytics.meta is
    // never updated by Intelligems on this store, so falling back to it
    // would silently use the original (non-test) price for anchor math.
    var price = parsePriceFromDOM() || getInitialVariantPrice();
    if (price) renderPDPBlock(price);
    setATCButtonText();
  }

  // ── Cart Drawer ──────────────────────────────────────────────────────

  function buildFakeDrawerTotals(
    inflatedPrice,
    halfSavings,
    extraSavings,
    realTotal
  ) {
    return (
      '<div class="c-fake-drawer-row c-fake-drawer-row--subtotal">' +
      "<span>Subtotal</span>" +
      "<s>" +
      formatMoney(inflatedPrice) +
      "</s>" +
      "</div>" +
      '<div class="c-fake-drawer-row c-fake-drawer-row--discount">' +
      '<span class="c-fake-drawer-discount-label">' +
      discountTagSVG +
      "<strong>EARLY BLACK FRIDAY DISCOUNT</strong></span>" +
      "<span>-" +
      formatMoney(halfSavings) +
      "</span>" +
      "</div>" +
      (extraSavings > 0
        ? '<div class="c-fake-drawer-row c-fake-drawer-row--discount">' +
          '<span class="c-fake-drawer-discount-label">' +
          discountTagSVG +
          "<strong>EXTRA 20%</strong></span>" +
          "<span>-" +
          formatMoney(extraSavings) +
          "</span>" +
          "</div>"
        : "") +
      '<div class="c-fake-drawer-row c-fake-drawer-row--total">' +
      "<strong>Total</strong>" +
      '<span class="c-fake-drawer-total-price">' +
      formatMoney(realTotal) +
      "</span>" +
      "</div>"
    );
  }

  function runCartDrawer(cartDrawer, cart) {
    if (!cart.item_count) return;

    var prices = calcAnchorPrices(cart.total_price);
    var halfSavings = prices.inflatedPrice - prices.halfPrice;
    var extraSavings = prices.halfPrice - cart.total_price;

    var totalsEl = cartDrawer.querySelector(".cart-drawer__totals");
    if (totalsEl) {
      var existing = cartDrawer.querySelector(".c-fake-drawer-totals");
      if (existing) existing.remove();
      var fakeEl = document.createElement("div");
      fakeEl.className = "c-fake-drawer-totals";
      fakeEl.innerHTML = buildFakeDrawerTotals(
        prices.inflatedPrice,
        halfSavings,
        extraSavings,
        cart.total_price
      );
      totalsEl.insertAdjacentElement("afterend", fakeEl);
    }

    cart.items.forEach(function (item, index) {
      var itemEl = cartDrawer.querySelector("#CartDrawer-Item-" + (index + 1));
      if (!itemEl) return;
      var priceWrapper = itemEl.querySelector(".cart-item__price-wrapper");
      if (!priceWrapper) return;

      var halfPerUnit = Math.round(item.price / 0.8);
      var inflatedPerUnit = halfPerUnit * 2;

      priceWrapper.innerHTML =
        '<div class="cart-item__discounted-prices">' +
        '<span class="price--end regular-price accent-color-accent-1">' +
        formatMoney(halfPerUnit) +
        "</span>" +
        '<s class="cart-item__old-price price--end compare-price color-foreground-text">' +
        formatMoney(inflatedPerUnit) +
        "</s>" +
        "</div>";
    });
  }

  // ── Main Cart Page ───────────────────────────────────────────────────

  function runCartPage(cart) {
    if (!cart.item_count) return;

    var prices = calcAnchorPrices(cart.total_price);
    var halfSavings = prices.inflatedPrice - prices.halfPrice;
    var extraSavings = prices.halfPrice - cart.total_price;

    var totalsEl = document.querySelector(".totals");
    if (!totalsEl) return;

    var existing = document.querySelector(".c-fake-cart-totals");
    if (existing) existing.remove();

    var fakeEl = document.createElement("div");
    fakeEl.className = "c-fake-cart-totals";
    fakeEl.innerHTML =
      '<div class="c-fake-cart-totals__row">' +
      "<span>Original Price</span>" +
      '<s class="c-fake-cart-totals__original">' +
      formatMoney(prices.inflatedPrice) +
      "</s>" +
      "</div>" +
      '<div class="c-fake-cart-totals__row c-fake-cart-totals__discount">' +
      "<span>Half Price Deal</span>" +
      "<span>-" +
      formatMoney(halfSavings) +
      "</span>" +
      "</div>" +
      (extraSavings > 0
        ? '<div class="c-fake-cart-totals__row c-fake-cart-totals__discount">' +
          "<span>Extra 20% OFF</span>" +
          "<span>-" +
          formatMoney(extraSavings) +
          "</span>" +
          "</div>"
        : "") +
      '<div class="c-fake-cart-totals__row c-fake-cart-totals__total">' +
      "<span>You Pay</span>" +
      "<span>" +
      formatMoney(cart.total_price) +
      "</span>" +
      "</div>";

    totalsEl.insertAdjacentElement("afterend", fakeEl);
  }

  function fetchAndRunCart() {
    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) runCartDrawer(cartDrawer, cart);
        if (window.location.pathname === "/cart") runCartPage(cart);
      });
  }

  // ── Card Prices (collection, search, recommendations) ────────────────

  function parsePriceText(text) {
    var match = text.replace(/,/g, "").match(/\d+\.\d{2}/);
    if (!match) match = text.replace(/,/g, "").match(/\d+/);
    return match ? Math.round(parseFloat(match[0]) * 100) : null;
  }

  function applyAnchorToCard(priceEl) {
    if (priceEl.dataset.cAnchorDone) return;
    if (priceEl.closest(".product-page-price")) return;
    if (
      priceEl.closest(".cart-item") ||
      priceEl.closest("cart-drawer") ||
      priceEl.closest(".cart")
    )
      return;

    var saleEl = priceEl.querySelector(".price__sale .price-item--sale");
    var regularEl = priceEl.querySelector(
      ".price__regular .price-item--regular"
    );
    var sourceEl = saleEl || regularEl;
    if (!sourceEl) return;

    var priceInCents = parsePriceText(sourceEl.textContent.trim());
    if (!priceInCents || priceInCents <= 0) return;

    var prices = calcAnchorPrices(priceInCents);

    // Stop Intelligems from re-overwriting our anchor display on this card.
    // We've already captured the test price into `priceInCents` above, so
    // there's nothing left for IG to do on these spans — anchor owns them.
    detachIntelligemsHooks(priceEl);

    priceEl.classList.add("price--on-sale");

    var saleDiv = priceEl.querySelector(".price__sale");
    if (!saleEl && saleDiv) saleEl = saleDiv.querySelector(".price-item--sale");
    if (saleEl) saleEl.textContent = formatMoney(prices.halfPrice);

    var compareEl = priceEl.querySelector("s.price-item--regular");
    if (compareEl) {
      compareEl.textContent = formatMoney(prices.inflatedPrice);
    } else if (saleDiv) {
      var wrapper = document.createElement("span");
      wrapper.className = "price__compare-price";
      wrapper.innerHTML =
        '<s class="price-item price-item--regular">' +
        formatMoney(prices.inflatedPrice) +
        "</s>";
      saleDiv.appendChild(wrapper);
    }

    priceEl.dataset.cAnchorDone = "1";
  }

  function runCardPrices() {
    document.querySelectorAll(".price").forEach(function (el) {
      applyAnchorToCard(el);
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      runPDP();
      runCardPrices();
      fetchAndRunCart();
    });
  } else {
    runPDP();
    runCardPrices();
    fetchAndRunCart();
  }

  // Lazy-loaded sections (recommendations, recently viewed, etc.)
  // Defer per-mutation processing so Intelligems has a tick to replace
  // prices on the new nodes before we read them.
  var cardObserver = new MutationObserver(function (mutations) {
    var addedNodes = [];
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) addedNodes.push(node);
      });
    });
    if (addedNodes.length === 0) return;
    setTimeout(function () {
      addedNodes.forEach(function (node) {
        node.querySelectorAll &&
          node.querySelectorAll(".price").forEach(function (el) {
            applyAnchorToCard(el);
          });
        if (node.classList && node.classList.contains("price"))
          applyAnchorToCard(node);
      });
    }, POST_MUTATION_DEFER_MS);
  });
  cardObserver.observe(document.body, { childList: true, subtree: true });

  // Variant change — standard Shopify event
  document.addEventListener("variant:change", function (e) {
    var variant = e.detail && e.detail.variant;
    if (variant && variant.price) updatePDPBlock(variant.price);
    setTimeout(setATCButtonText, 50);
  });

  // MutationObserver fallback for variant price updates on PDP
  var priceContainer = document.querySelector(".product-page-price");
  if (priceContainer) {
    var pdpObserver = new MutationObserver(function () {
      var price = parsePriceFromDOM();
      if (price) updatePDPBlock(price);
    });
    pdpObserver.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // ATC button text — keep persistent via MutationObserver
  var atcBtn = document.querySelector(".main-product-atc");
  if (atcBtn) {
    var atcObserver = new MutationObserver(function () {
      var label = atcBtn.querySelector(".main-atc__label__text");
      if (label && label.textContent !== "Add to Cart & Get An Extra 20% OFF") {
        atcObserver.disconnect();
        setATCButtonText();
        atcObserver.observe(atcBtn, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    });
    atcObserver.observe(atcBtn, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // Cart drawer — re-run whenever drawer content updates
  var cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    var drawerObserver = new MutationObserver(function () {
      if (
        cartDrawer.querySelector(".cart-drawer__totals") &&
        !cartDrawer.querySelector(".c-fake-drawer-totals")
      ) {
        fetchAndRunCart();
      }
    });
    drawerObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Cart page refresh event
  document.addEventListener("cart:refresh", function () {
    var existing = document.querySelector(".c-fake-cart-totals");
    if (existing) existing.remove();
    fetchAndRunCart();
  });

  } // end init

  // Defer the entire anchor pipeline until Intelligems has finished its
  // initial price replacement, so anchoring always reads the post-IG
  // (i.e. test-variant) prices instead of the original Liquid-rendered
  // prices.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      whenIntelligemsReady(init);
    });
  } else {
    whenIntelligemsReady(init);
  }
})();
